var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex mt-2 sticky-box justify-center"},[_c('SaveOfferButton',{attrs:{"disabled":_vm.isSaveDisabled},on:{"onSaveClicked":_vm.saveOffer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }